import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import Image from '../../assets/images/Licensed Key (1).svg';
import { GoldenButton } from '../Home/CreateAnnounce/CreateAnnounce.style';
import { ConfirmationBox } from './Announcement.style';
import axiosInstance from '../../core/axiosInstance';
import { toast } from 'react-toastify';
import { setLoading } from '../../features/loading/loadingSlice';
import { useAppDispatch } from '../../core/hooks';
import Preview from '../Preview/Preview';
import { SmallSizeScreen } from '../Home/Home.style';
import maintenance from '../../assets/images/maintenance.png'

const AnnouncementGard = () => {
  
  useEffect(() => {
    axiosInstance.get('/check-expired').then().catch((err)=>{
      if (err.response.status === 400 && !err.response.license) {
        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_CENTER,
          toastId: 'uniqueId',
        });
        window.location.replace(window.location.origin +'/expired');
        
      }
    })
  }, [])
  const dispatch = useAppDispatch();

  const announcementKey: string | null = localStorage.getItem('announcement-key');

  const [keyValue, setKeyValue] = useState<string>('');
  const [err, setErr] = useState<string | null>(null);

  const [pass, setPass] = useState<boolean>(false);

  // const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [size, setSize] = useState({width:window.innerWidth,height:window.innerHeight});


  useEffect(() => {
    const handleWindowResize = () => {
      // setWindowWidth(window.innerWidth);
      setSize({...size,width:window.innerWidth,height:window.innerHeight})
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  });
  const handellSubmit = async () => {
    if (keyValue === '') {
      setErr('Required');
    } else {
      await axiosInstance
        .post<any>('get/viewer/token', { key: keyValue })
        .then((res) => {
          localStorage.setItem('announcement-key', res.data?.token);
          setPass(true);
        })
        .catch((err: any) => {
          if (err.response.status === 422 || err.response.status === 403) {
          } else {
            toast.error(err.response?.data.message, {
              position: toast.POSITION.TOP_CENTER,
            });
          }
          dispatch(setLoading(false));
        });
    }
  };

  useEffect(() => {
    if (announcementKey) {
      setPass(true);
    }
  }, [announcementKey]);

  if(size.width<=600||size.height<=300){
    return(
      <SmallSizeScreen>
         <img className='maintenanceImg'  src={maintenance} alt='forbiden'  />
        <h2>This screen size is not supported for  this application</h2>

      </SmallSizeScreen>
  )
  }else if (!pass) {
    return (
      <ConfirmationBox>
        <div className="box">
          <img src={Image} alt="Licensed Key" />
          <h2>Please Enter Your License Key</h2>
          <div className="inputContainer">
            <InputText
              type="text"
              id="key"
              value={keyValue}
              onChange={(e) => setKeyValue(e.target.value)}
              placeholder="License Key"
              className={`${classNames({
                'p-invalid': err,
                'p-mt-2': true,
              })}`}
              style={{width:"60%"}}
            />
            <GoldenButton type="submit" onClick={handellSubmit}>
              Submit
            </GoldenButton>
          </div>
        </div>
      </ConfirmationBox>
    );
  } else {
    return <Preview />;
  }
};

export default AnnouncementGard;
